import { render, staticRenderFns } from "./bottomRight3.vue?vue&type=template&id=1ddd2fe4&scoped=true&"
import script from "./bottomRight3.vue?vue&type=script&lang=js&"
export * from "./bottomRight3.vue?vue&type=script&lang=js&"
import style0 from "./bottomRight3.vue?vue&type=style&index=0&id=1ddd2fe4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd2fe4",
  null
  
)

export default component.exports